module.exports = __webpack_public_path__ + "img/shanghai doll.502b9ae3.png";